// import cx from 'classnames';
import { useState, useEffect } from 'react';
// import { Form } from 'react-bootstrap';
import {
  // updatePublicLink,
  // getPublicLink,
  // updateSceneOptimistic,
  updateAllSceneToken,
} from '../../../api/configuratorApi';
import { ButtonV2 } from '../../ButtonV2/ButtonV2';
import styles from './ShareDialog.module.scss';
import Switch from '../../admin/switch/index';
import { icons } from '../../../assets';
import { selectConfiguratorData } from '../../../redux/slicers/configurator/configurator.slicer';
import { useSelector } from 'react-redux';
import { successToastV2 } from '../../../helpers/toastHelper';
import Loader from '../../Loader/Loader';
// import { OverlayTrigger, Tooltip } from 'react-bootstrap';
// import isEmail from 'validator/lib/isEmail';
// import { CopyToClipboard } from './CopyToClipboard';
import { ShareContent } from './ShareContent';
import { Image } from '../../../common';
import { useCopyToClipboard } from 'react-use';
import { getUrlOrIframeUrlWithToken } from '../utils';

const { IFrameIcon, LinkIcon } = icons;

export const TabShareExternal = ({ data, title, scenesData, allData, description }) => {
  // const [addedEmail, setAddedEmail] = useState('');
  // const [emailError, setEmailError] = useState('');
  const [externalToggleValue, setExternalToggleValue] = useState(Boolean(allData?.is_active));
  const configuratorData = useSelector(selectConfiguratorData);
  const [loading, setLoading] = useState(false);
  const v2 = data?.version_type === 'V2';
  // const dispatch = useDispatch();
  // const [allAddedEmails, setAllAddedEmails] = useState([]);
  const [state, copy] = useCopyToClipboard();
  const [scenes, setScenes] = useState([]);
  const token = allData?.unique_id || configuratorData?.token || data?.token;

  useEffect(() => {
    const filteredScenes = scenesData.filter((val) => val?.scene_data?.is_enable);
    setScenes(filteredScenes);
  }, [scenesData]);

  // useEffect(() => {
  //   getSharePopupValues();
  // }, []);

  // const getSharePopupValues = async () => {
  //   setLoading(true);
  //   const result = await getPublicLink(configuratorData?.token || token);
  //   const data = result?.results || [];
  //   if (data?.length) {
  //     if (data[0]?.emails) {
  //       let emails = data[0]?.emails;
  //       emails = emails.split(', ').filter((em) => em && em != '');
  //       setAllAddedEmails(emails);
  //     }
  //     setExternalToggleValue(data[0]?.is_active);
  //   }
  //   setLoading(false);
  // };

  // const handleInvite = async () => {
  //   if (validateEmail(addedEmail)) {
  //     setLoading(true);
  //     const result = await updatePublicLink({
  //       token: configuratorData.token || token,
  //       isActive: externalToggleValue,
  //       email: addedEmail.toString(),
  //     });
  //     if (result?.status && result?.data?.id) {
  //       const addedEmailCopy = JSON.parse(JSON.stringify(addedEmail));
  //       successToastV2(`Invite sent to ${addedEmailCopy}`);
  //       setAddedEmail('');
  //       setEmailError('');
  //       getSharePopupValues();
  //     }
  //     setLoading(false);
  //   }
  // };

  // const handleChange = (e) => {
  //   if (!e.target.value) {
  //     setEmailError('Please add email');
  //   }
  //   setAddedEmail(e.target.value.trim());
  // };

  // const validateEmail = (emailValue) => {
  //   if (isEmail(emailValue)) {
  //     setEmailError('');
  //     return true;
  //   }
  //   setEmailError('Invalid Email');
  //   return false;
  // };

  // const handleBlur = (e) => {
  //   validateEmail(e.target.value);
  //   if (!e.target.value) {
  //     setEmailError('');
  //   }
  // };

  const changeToggleValue = async () => {
    setLoading(true);
    const result = await updateAllSceneToken({
      data: { is_active: !externalToggleValue },
      id: data?.id,
      token,
      sceneLinkType: 'ALL',
      v2,
    });
    if (result?.status) {
      setExternalToggleValue(!externalToggleValue);
      successToastV2(`Public Share is ${!externalToggleValue ? 'enabled' : 'disabled'} 
      for this configurator`);
    }
    setLoading(false);
  };

  // const renderTooltip = (props) => {
  //   return <Tooltip>{props}</Tooltip>;
  // };

  const changeToggleValueScene = async (scene) => {
    setLoading(true);
    const result = await updateAllSceneToken({
      data: { is_active: !scene?.is_active },
      id: data?.id,
      token: scene?.unique_id,
      sceneLinkType: 'SCENE',
      v2,
    });
    if (result?.status) {
      const allScenes = [...scenes];
      allScenes?.map((val) => {
        if (scene.scene === val.scene) {
          val.is_active = !scene?.is_active;
        }
        return val;
      });
      setScenes(allScenes);
      successToastV2(`Scene link ${scene?.is_active ? 'enabled' : 'disabled'} successfully`);
    }
    setLoading(false);
  };

  const sceneListItem = (scene) => {
    return (
      <div className={`w-100 d-flex ${styles.sceneListItem}`} key={scene.scene}>
        <div className={`${styles.sceneImage} d-flex justify-content-start align-items-center`}>
          <Image
            src={scene?.thumbnail}
            rounded={false}
            ratio={1.2}
            iconFontSize={18}
            placeholderWhileLoading
          />
        </div>
        <div
          className={`${styles.sceneTitle} px-2 d-flex justify-content-start align-items-center`}>
          <span className={`${styles.listItemTitle} ellipsis`} title={scene.name}>
            {scene.name}
          </span>
        </div>
        <div
          className={`${styles.sceneIconContainer} d-flex justify-content-end align-items-center`}>
          {scene?.is_active && (
            <>
              <ButtonV2
                className={styles.transparentBtn}
                onClick={() => {
                  const link = getUrlOrIframeUrlWithToken({ token: scene?.unique_id });
                  copy(link);
                  successToastV2('Link copied');
                }}>
                <LinkIcon />
              </ButtonV2>
              <ButtonV2
                className={`mx-3 ${styles.transparentBtn}`}
                onClick={() => {
                  const link = getUrlOrIframeUrlWithToken({
                    token: scene?.unique_id,
                    isIframe: true,
                  });
                  copy(link);
                  successToastV2('Iframe copied');
                }}>
                <IFrameIcon />
              </ButtonV2>
            </>
          )}
          <Switch
            checked={scene?.is_active}
            onToggle={() => changeToggleValueScene(scene)}
            toggleId={'1'}
          />
        </div>
      </div>
    );
  };

  const addEmail = () => {
    return (
      <div className="w-100 h-100 position-relative">
        <div className={styles.innerContainer}>
          <div className="w-100 mt-3 d-flex justify-content-between">
            <div>
              <ShareContent title={title} description={description}></ShareContent>
            </div>
            <div className={styles.toggleContainer}>
              <Switch checked={externalToggleValue} onToggle={changeToggleValue} toggleId={'1'} />
            </div>
          </div>
          {/* {externalToggleValue && (
            <>
              <Form.Group className={cx(styles.formGroup, 'pt-0', styles.mt10)}>
                <div className="w-100">
                  <Form.Control
                    type="text"
                    name="email"
                    className={cx(styles.emailText)}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter email address"
                    value={addedEmail}
                  />
                  {emailError && <span className={styles.emailError}>{emailError}</span>}
                </div>
                <ButtonV2
                  color="dark"
                  variant="transparent"
                  size="sm"
                  onClick={handleInvite}
                  disabled={emailError || !addedEmail}>
                  Invite
                </ButtonV2>
              </Form.Group>
              {!!allAddedEmails?.length && (
                <Form.Group className="d-flex">
                  <div className={styles.mt4}>Shared with: </div>
                  <div>
                    <ul className={styles.userList}>
                      {allAddedEmails.map((em, index) => {
                        return (
                          <OverlayTrigger
                            overlay={renderTooltip(em)}
                            placement="bottom"
                            key={index}>
                            <li className={styles.userLink}>{em[0]}</li>
                          </OverlayTrigger>
                        );
                      })}
                    </ul>
                  </div>
                </Form.Group>
              )}
              <div className={styles.copyLink}>
                <Form.Group>
                  <CopyToClipboard
                    btnText="Copy link"
                    textToBeCopied={linkToCopy}
                    successText="Link copied to clipboard"
                  />
                </Form.Group>
              </div>
            </>
          )} */}
          <div className={`w-100 ${styles.sceneListContainer}`}>
            <div className="w-100 d-flex justify-content-start align-items-center">
              <h6 className={styles.title}>All scenes</h6>
            </div>
            <div className={`w-100 ${styles.allScenesContainer} ${styles.overflowScrollHide}`}>
              {scenes.map((scene) => sceneListItem(scene))}
            </div>
          </div>
        </div>
        <div className={`w-100 d-flex justify-content-end align-items-center ${styles.footer}`}>
          <ButtonV2
            color="dark"
            size="xxs"
            onClick={() => {
              const link = getUrlOrIframeUrlWithToken({
                token,
              });
              copy(link);
              successToastV2('Link copied');
            }}
            disabled={!externalToggleValue}>
            <LinkIcon className={styles.whiteIcon} style={{ height: '16px' }} />
            Copy link
          </ButtonV2>
          <ButtonV2
            color="dark"
            size="xxs"
            className="ms-2"
            onClick={() => {
              const link = getUrlOrIframeUrlWithToken({
                token,
                isIframe: true,
              });
              copy(link);
              successToastV2('Iframe copied');
            }}
            disabled={!externalToggleValue}>
            <IFrameIcon className={styles.whiteIcon} style={{ height: '16px' }} />
            Copy iframe
          </ButtonV2>
        </div>
        <Loader loading={loading} backdrop thickness={3} position="absolute" />
      </div>
    );
  };

  return addEmail();
};
